import loginPage from "./LoginPage.js";
import switchRoutes from "./SwitchRoutes.js";
import userName from "./UserName.js";
import tempUser from "./TempUser.js";
import theme from "./Theme.js";
import text from "./Text.js";
import code from "./Code.js";
import token from "./Token.js";
import display from "./Display.js";
import noti from "./Noti.js";
import { combineReducers } from 'redux';

const allReducers = combineReducers({
    loginPage,
    switchRoutes,
    userName,
    tempUser,
    theme,
    token,
    text,
    display,
    code,
    noti
});

export default allReducers;